import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "albums-list" }
const _hoisted_2 = {
  key: 1,
  class: "album__image album__image--placeholder"
}

import { defineAsyncComponent } from 'vue';

import * as utils from '@services/utils/common';
import * as dav from '@services/dav';
import { routes } from '@services/router';

import type { IAlbum, IPhoto } from '@typings';

import ImageMultipleIcon from 'vue-material-design-icons/ImageMultiple.vue';
import XImg from '@components/frame/XImg.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AlbumsList',
},
  __name: 'AlbumsList',
  props: {
    albums: {},
    link: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const NcListItem = defineAsyncComponent(() => import('@nextcloud/vue/components/NcListItem'));



const props = __props;

const emit = __emit;



function click($event: Event, album: IAlbum) {
  if (!props.link) {
    $event.preventDefault();
  }
  emit('click', album);
}

function linkTarget(album: IAlbum) {
  return {
    name: routes.Albums.name,
    params: {
      name: album.name,
      user: album.user,
    },
  };
}

function toCoverUrl(album: IAlbum): string | undefined {
  // See Cluster.vue for the original implementation
  const preview = (fileid: number, etag: string | number) =>
    utils.getPreviewUrl({
      photo: {
        fileid: fileid,
        etag: etag.toString(),
      } as IPhoto,
      sqsize: 512,
    });

  if (album.cover && album.cover_etag) {
    return preview(album.cover, album.cover_etag);
  }

  if (album.last_added_photo && album.last_added_photo !== -1) {
    return preview(album.last_added_photo, album.last_added_photo_etag ?? album.album_id);
  }

  return undefined;
}

function getSubtitle(album: IAlbum) {
  return dav.getAlbumSubtitle(album);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.albums, (album) => {
      return (_openBlock(), _createBlock(_unref(NcListItem), {
        class: "album",
        key: album.album_id,
        name: album.name,
        "aria-label": album.name,
        to: __props.link ? linkTarget(album) : undefined,
        exact: true,
        onClick: ($event: any) => (click($event, album))
      }, {
        icon: _withCtx(() => [
          (toCoverUrl(album))
            ? (_openBlock(), _createBlock(XImg, {
                key: 0,
                class: "album__image",
                src: toCoverUrl(album)
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(ImageMultipleIcon, { size: 32 })
              ]))
        ]),
        subname: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(getSubtitle(album)), 1)
        ]),
        extra: _withCtx(() => [
          _renderSlot(_ctx.$slots, "extra", { album: album })
        ]),
        _: 2
      }, 1032, ["name", "aria-label", "to", "onClick"]))
    }), 128))
  ]))
}
}

})